module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Ball Park")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/additional.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("This novel is dedicated to a certain gentleman")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("who reads crime fiction voraciously")]), _vm._v(" "), _c('p', {
    staticClass: "dedication-space-after"
  }, [_vm._v("and collects these books with a grand passion.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("Steele Curry, you are a writer’s reader.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("While you have read thousands of crime novels,")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("know that this one is dedicated to you")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("with boundless appreciation.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 72
// module chunks = 0